import { Button, Grid, Input, Modal } from '@mui/joy';
import { DataGrid } from '@mui/x-data-grid';
import React, { useCallback, useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import './assistat.css';
import { templateList } from './Templates/TemplatesList';
import 'draft-js/dist/Draft.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import axios from 'axios';
import { endpoint } from '../../../resource/Constant';
import { Backdrop, CircularProgress, debounce } from '@mui/material';
// import draftToHtml from 'draftjs-to-html';

export default function CreateDescription({ setShowPage }) {
  const [rows, setRows] = useState([]);
  const [suggestionRows, setSuggestionContent] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuggestionLoading, setIsSuggestionLoading] = useState(false);
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [position, setPosition] = useState();
  const [submitDescription, setSubmitDescription] = useState(false);

  const getTemplates = () => {
    setRows(templateList);
  };
  const getSuggestions = (html) => {
    setIsSuggestionLoading(true);
    const param = { description: html || draftToHtml(convertToRaw(editorState.getCurrentContent())) };
    axios
      .post(`${endpoint}/api/aichatbot/generatesuggetions`, null, {
        params: { ...param },
        headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` }
      })
      .then((res) => {
        setSuggestionContent(res?.data?.map((sug) => ({ ...sug, added: false })));
        setIsSuggestionLoading(false);
      })
      .catch((err) => {
        setIsSuggestionLoading(false);
      });
  };

  const addSuggetion = (suggetion_id) => {
    let param = { description: '', suggetion: '' };
    setSuggestionContent((prev) =>
      prev?.map((sug) => {
        if (sug?.id == suggetion_id) {
          param.suggetion = `old_content:${sug?.old_content},new_content:${sug?.new_content}`;
          return { ...sug, added: true };
        } else {
          return { ...sug };
        }
      })
    );
    param.description = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    axios
      .post(`${endpoint}/api/aichatbot/addSuggetions`, null, {
        params: { ...param },
        headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` }
      })
      .then((res) => {
        setEditorState((prev) => {
          const blocksFromHTML = htmlToDraft(res?.data?.jobDescription || '');
          const state = ContentState.createFromBlockArray(blocksFromHTML);
          return EditorState.createWithContent(state);
        });
      })
      .catch((err) => {});
  };

  const saveDescription = (e) => {
    setIsLoading(true);
    e.preventDefault();
    let param = { description: '', position: '' };
    param.description = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    param.position = position;
    axios
      .post(`${endpoint}/api/aichatbot/adddescription`, null, {
        params: { ...param },
        headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` }
      })
      .then((res) => {
        setIsLoading(false);
        setPosition();
        setSubmitDescription(false);
        setShowPage((prev) => !prev);
      })
      .catch((err) => {
        setIsLoading(false);
        setPosition();
        setSubmitDescription(false);
      });
  };

  const columns = [
    {
      field: 'Templates',
      headerName: 'Templates',
      sortable: false,
      flex: 1,
      renderCell: (ticket) => {
        return (
          <>
            <Grid container spacing={1}>
              <Button
                variant="contained"
                onClick={() => {
                  getSuggestions(ticket?.row?.data);
                  setEditorState(() => {
                    const blocksFromHTML = htmlToDraft(ticket?.row?.data || '');
                    const state = ContentState.createFromBlockArray(blocksFromHTML);
                    return EditorState.createWithContent(state);
                  });
                }}
                fullWidth
                sx={{
                  background: '#3c3c3c',
                  color: '#FFFFFF',
                  fontSize: '0.3rem !important',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Grid item xs={9} md={9}>
                  <h5 style={{ overflow: 'clip' }}>{ticket?.row?.technology}</h5>
                </Grid>
                <Grid item xs={3} md={3}>
                  <h6>{ticket?.row?.experience}</h6>
                </Grid>
              </Button>
            </Grid>
          </>
        );
      }
    }
  ];

  const suggestionColumns = [
    {
      field: 'Suggestions',
      headerName: 'Suggestions',
      sortable: false,
      flex: 1,
      height: '200px',
      renderCell: (suggest) => {
        return (
          <>
            <Grid container spacing={1}>
              <Button
                // sx={{ backgroundColor: suggest?.row?.added ? 'green' : 'white', color: 'black' }}
                sx={{ backgroundColor: '#3c3c3c' }}
                disabled={suggest?.row?.added}
                onClick={() => {
                  addSuggetion(suggest?.row?.id);
                }}
                fullWidth
              >
                <Grid container sx={{ overflow: 'auto' }}>
                  <Grid sx={{ overflow: 'auto' }} item xs={10} md={10}>
                    <p>{suggest?.row?.reasone}</p>
                  </Grid>
                  <Grid sx={{ overflow: 'auto', color: 'red' }} item xs={10} md={10}>
                    <div dangerouslySetInnerHTML={{ __html: suggest?.row?.old_content ? suggest?.row?.old_content : '<p></p>' }}></div>
                  </Grid>
                  <Grid sx={{ overflow: 'auto', color: 'green' }} item xs={10} md={10}>
                    <div dangerouslySetInnerHTML={{ __html: suggest?.row?.new_content ? suggest?.row?.new_content : '<p></p>' }}></div>
                  </Grid>
                </Grid>
              </Button>
            </Grid>
          </>
        );
      }
    }
  ];
  const handleBlur = (e) => {
    if (e?.relatedTarget?.id === 'keyWord' || e?.relatedTarget?.id === 'addKeyword') {
      return;
    } else {
      //   setTest(false);
      //   setFormError({ ...formError, keywordError: false });
    }
  };

  useEffect(() => {
    getTemplates();
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item sx={12} md={2}>
        <DataGrid
          columns={columns}
          rows={rows}
          rowCount={rows?.length}
          pageSizeOptions={[5]}
          paginationMode="server"
          paginationModel={{ page: 0, pageSize: 100 }}
          loading={isLoading}
          getRowHeight={() => 'auto'}
          sx={{
            height: '90vh',
            '& .MuiDataGrid-columnHeader': {
              background: '#8abfc2',
              color: '#000000',
              fontSize: '20px',
              // font: 'bold',
              fontWeight: '500',

              // height: '50px',
              justifyContent: 'center',
              alignItems: 'center'
            }
            // '& .MuiDataGrid-row': {
            //   background: '#3c3c3c',
            //   color: 'white',
            //   fontSize: '5px',
            //   // font: 'bold',
            //   fontWeight: '700',
            //   letterSpacing: '0.02em',

            //   // height: '50px',
            //   justifyContent: 'center',
            //   alignItems: 'center'
            // }
          }}
        />
      </Grid>
      <Grid item sx={12} md={7}>
        <Editor
          className="description-editor"
          toolbar={{
            options: [
              'inline',
              'blockType',
              'fontSize',
              'fontFamily',
              'list',
              'textAlign',
              'colorPicker',
              'link',
              'embedded',
              'emoji',
              'remove',
              'history'
            ],
            inline: { inDropdown: true },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            history: { inDropdown: true }
            // image: { alt: { present: true, mandatory: true } }
          }}
          editorState={editorState}
          onEditorStateChange={(event) => {
            setEditorState(event);
          }}
          wrapperClassName="wrapper-class"
          // onFocus={handleFocus}
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          onBlur={handleBlur}
          editorStyle={{
            height: '90vh',
            padding: '10px'
          }}
          wrapperStyle={{
            backgroundColor: 'white',
            borderRadius: '10px',
            border: 'solid 1px black'
          }}
        />
      </Grid>

      <Grid container item sx={12} md={3}>
        <Grid item sx={12} md={12}>
          <Button
            onClick={() => {
              getSuggestions();
            }}
          >
            Get More Suggetions
          </Button>
          <Button
            onClick={() => {
              setSubmitDescription(true);
            }}
          >
            Save Description
          </Button>
        </Grid>
        <Grid item sx={12} md={12}>
          <DataGrid
            columns={suggestionColumns}
            rows={suggestionRows}
            rowCount={suggestionRows?.length}
            pageSizeOptions={[5]}
            paginationMode="server"
            paginationModel={{ page: 0, pageSize: 100 }}
            loading={isSuggestionLoading}
            getRowHeight={() => 'auto'}
            sx={{
              height: '90vh',
              '& .MuiDataGrid-columnHeader': {
                background: '#8abfc2',
                color: '#000000',
                fontSize: '20px',
                // font: 'bold',
                fontWeight: '500',

                // height: '50px',
                justifyContent: 'center',
                alignItems: 'center'
              }
            }}
          />
        </Grid>
      </Grid>
      {submitDescription && (
        <Modal
          open={submitDescription}
          onClose={() => {
            setPosition();
            setSubmitDescription(false);
          }}
        >
          <>
            <Grid
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: 300, md: 500 },
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                pt: 2,
                px: 4,
                pb: 3
              }}
            >
              <form onSubmit={saveDescription}>
                <Grid container spacing={2}>
                  <Grid item>
                    <Input
                      type="text"
                      value={position}
                      onChange={(e) => {
                        setPosition(e.target.value);
                      }}
                      required
                      placeholder="Profile Name"
                    ></Input>
                  </Grid>
                  <Grid item>
                    <Button type="submit">Add Profile</Button>
                  </Grid>
                </Grid>
              </form>
            </Grid>
            <Backdrop open={isLoading}>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
            </Backdrop>
          </>
        </Modal>
      )}
    </Grid>
  );
}
